export class Period {
    id: number;
    start: string;
    end: string;
    is_active: boolean;
    is_locked: boolean;
    schedule_id: number;
}
